module.exports = __webpack_public_path__ + "static/img/nody.1aa2aed4.png";